import React from "react";
import Image from "next/image";
import block from "bem-css-modules";
import card from "../../styles/components/Contactcard.module.scss";
import isEmpty from "lodash/isEmpty";

export default function ContactCard({ spaceTop, spaceBottom, employeeDetails }) {
  block.setSettings({
    modifierDelimiter: "--",
  });

  const contact = block(card);
  return (
    <div className={contact("")}>
      <div
        className={
          `${contact("wrapper")}` +
          " " +
          `${spaceTop && contact("wrapper--spaceTop")}` +
          " " +
          `${spaceBottom && contact("wrapper--spaceBottom")}`
        }
      >

      {!isEmpty(employeeDetails) && employeeDetails.map((item, index)=>(
        <section className={contact("row")} key={index}>
          <div className={contact("image")}>
            <Image
              src={item?.Image?.url || ''}
              alt={"testimonial"}
              width={160}
              height={160}
              layout="responsive"
              className={contact("employeeImage")}
            />
          </div>
          <div className={contact("details")}>
            <h3 className={contact("head")}>{item?.Name || ''}</h3>
            <p className={contact("info", {rank: true})}>{item?.Title || ''} </p>
            <p className={contact("info")}>Email: {item?.Email || ''} </p>
            <p className={contact("info")}>Phone: {item?.Phone || ''} </p>
          </div>
        </section>

      ))}
        
      </div>
    </div>
  );
}
